import { P2GBox } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { useContext, useEffect, useState } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { SmartSendItemsCache } from '../../../lib/cache/SmartSendItemsCache';
import { SmartSendContext } from '../../../lib/context/SmartSendContext';
import { GetSelectionBasedOnAction } from '../../../lib/helpers/GetSelectionBasedOnAction';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import MarketplaceStatusObserver from './MarketplaceStatusObserver';

interface props {
  filterKey: string;
  affected: number;
  confirm?: () => void;
  cancel?: () => void;
}

export default function ConfirmDispatch(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const ctx = useContext(SmartSendContext);
  const [items, setItems] = useState<SmartSendItemApiModel[]>([]);
  useEffect(() => {
    setItems(GetSelectionBasedOnAction(props.filterKey, ctx.state, 'Dispatch', SmartSendItemsCache));
  }, []);

  return (
    <P2GBox>
      <MarketplaceStatusObserver
        key={`Items:${items.length}`}
        items={items}
        markAsDispatched={props.confirm}
        wrapper={(x) => <P2GBox>{x}</P2GBox>}
      />
      {props.cancel && (
        <P2GBox mt={2}>
          <P2GGrid container spacing={2}>
            <P2GGrid item>
              <P2GButton variant="primary" onClick={props.cancel}>
                {t('CANCEL_BUTTON', { defaultValue: 'Cancel' })}
              </P2GButton>
            </P2GGrid>
          </P2GGrid>
        </P2GBox>
      )}
    </P2GBox>
  );
}
